import ready from '../utils/ready';

const initializeModals = () => {
  // Open modal
  document.querySelectorAll('.usp-list__btn').forEach((el) => {
    el.addEventListener('click', () => {
      el.closest('.usp-list__item')?.querySelector('.modal')?.classList.add('modal--is-open');
    });
  });

  // Close modal (close button)
  document.querySelectorAll('.modal__action-btn').forEach((el) => {
    el.addEventListener('click', () => {
      el.closest('.modal')?.classList.remove('modal--is-open');
    });
  });

  // Close modal (ui-block)
  document.querySelectorAll('.modal__ui-block').forEach((el) => {
    el.addEventListener('click', () => {
      el.closest('.modal')?.classList.remove('modal--is-open');
    });
  });
};

ready(initializeModals);
